export const NAME = 'CashierReport';
export const CRUMB_LABEL_KEY = 'lstCashierReport';
export { DMS_MODULE } from '../constants';

export enum TAB_NAMES {
	DailyStatisticsByPayment = 'DAILY_STATISTICS_BY_PAYMENT',
}

export const TABS = {
	[TAB_NAMES.DailyStatisticsByPayment]: { id: TAB_NAMES.DailyStatisticsByPayment, labelKey: 'DAILY_STATISTICS_BY_PAYMENT' },
};

export const DAILY_STATISTICS_BY_PAYMENT = 'DailyStatisticsByPayment';

export const DEPENDENT_TABLES = <const>[
	DAILY_STATISTICS_BY_PAYMENT,
];
export type DependentTableNames = typeof DEPENDENT_TABLES[number];
export const entityId = '1';
export const MAX_DAYS = 31;
export const MIN_DAYS = 0;
